export function generateUniqueKey(): string {
  return `${Math.random().toString(36).substr(2)}-${new Date()
    .getTime()
    .toString()}`;
}
